export default __webpack_public_path__ + "static/media/default.5b9ec9917822651c5fcc64fa7f2b36f6.png";